import {StoreExt} from '@utils/reactExt'
import {observable, action, runInAction} from 'mobx'
import {userStore} from '@store/userStore'
import {orderListStore} from '../../ordering/actor/store'

class DeviceStore extends StoreExt {
    @observable loading: boolean = false
    @observable deviceList: any[] = []

    @action
    getDeviceList = async () => {
        runInAction(() => this.loading = true)
        try {
            const res = await this.api.getDeviceList({})
            runInAction(() => {
                this.loading = false
                this.deviceList = res
            })
        } catch (e) {
            runInAction(() => this.loading = false)
        }
    }

    @action
    switchDevice = (id) => {
        userStore.getDeviceDetail(id)
        userStore.updateSimId(id)
        orderListStore.reStoreCurrent()
        setTimeout(() => this.goToPath('/app/home'), 500)
    }
}

const deviceStore = new DeviceStore()
export {
    deviceStore,
    DeviceStore
}
